import type { LicensingRuleType, PolicyAction } from '../../../../shared/model-typings';

export const licensingRuleTypeToAction = (type: LicensingRuleType): PolicyAction => {
  switch (type) {
    case 'denied_license':
      return 'DENY';
    case 'flagged_license':
      return 'FLAG';
    case 'approved_license':
    default:
      return 'APPROVE';
  }
};

export const licensingRuleTypeToActionRevamp = (type: LicensingRuleType, isPlural: boolean = false): string => {
  switch (type) {
    case 'denied_license':
      return `Deny ${isPlural ? 'Licenses' : 'License'}`;
    case 'flagged_license':
      return `Flag ${isPlural ? 'Licenses' : 'License'}`;
    case 'approved_license':
    default:
      return `Approve ${isPlural ? 'Licenses' : 'License'}`;
  }
};
